// Anúncios mostrados só pra quem ainda não assina (somem no Premium).
// Por enquanto todos promovem o próprio Premium do ControleNext — solução improvisada até
// existir um parceiro de anúncio de verdade. O link de todos aponta pra rota interna /premium.
//
// IMAGE_ADS: anúncios pequenos — imagem, sem áudio, sempre visíveis (sem botão de fechar).
// Um aparece no Dashboard (entre o resumo do período e os gráficos) e outro em Lançamentos
// (entre os filtros e o resumo do período) — nenhum aparece dentro da lista de lançamentos.
// Pra ativar uma imagem de verdade, coloque o arquivo em /public/ads/ e preencha imageSrc
// (ex: "/ads/premium-banner.jpg"). Sem imageSrc, aparece um placeholder no lugar da imagem.
export interface ImageAdConfig {
  id: string;
  title: string;
  description: string;
  imageSrc?: string;
  ctaLabel: string;
  href: string;
}

// A ordem aqui é a ordem de rotação. Novos anúncios entram no fim da lista.
export const IMAGE_ADS: ImageAdConfig[] = [
  {
    id: "premium-calendario-metas",
    title: "ControleNext Premium",
    description: "Calendário financeiro, metas de economia e orçamento por categoria, sem limites.",
    ctaLabel: "Conhecer o Premium",
    href: "/premium",
  },
  {
    id: "premium-sem-anuncios",
    title: "Cansado dos anúncios?",
    description: "Assine o Premium e use o ControleNext inteiro, sem interrupções.",
    ctaLabel: "Ver planos",
    href: "/premium",
  },
];

// INTERSTITIAL_ADS: anúncio grande em tela cheia, mostrado a cada 2 lançamentos criados, logo
// depois de salvar. É o único anúncio que pode ser fechado (depois de 3s).
// Por enquanto só imagem (sem vídeo): coloque o arquivo em /public/ads/ e preencha imageSrc
// (ex: "/ads/premium-fullscreen.jpg", tamanho recomendado 1080x1440, proporção 3:4).
// Se um dia quiser trocar por vídeo de verdade, preenche videoSrc em vez de imageSrc - o
// componente prioriza vídeo se os dois estiverem preenchidos.
export interface InterstitialAdConfig {
  id: string;
  title: string;
  description: string;
  videoSrc?: string;
  posterSrc?: string;
  imageSrc?: string;
  ctaLabel: string;
  href: string;
}

export const INTERSTITIAL_ADS: InterstitialAdConfig[] = [
  {
    id: "premium-video-1",
    title: "Desbloqueie o ControleNext Premium",
    description: "Categorias personalizadas, calendário financeiro completo, metas e orçamento sem limites.",
    ctaLabel: "Assinar Premium",
    href: "/premium",
  },
];
